import React from 'react';
import './AboutCustomers2.css'; 
import customer1 from "../../assest/customers/customer1.jpg"; 
import customer2 from "../../assest/customers/customer2.jpg"; 
import customer3 from "../../assest/customers/customer3.jpg"; 
import customer4 from "../../assest/customers/customer4.jpg"; 
import customer5 from "../../assest/customers/customer5.jpg"; 
import customer6 from "../../assest/customers/customer6.jpg"; 
import customer7 from "../../assest/customers/customer7.jpg"; 
import customer8 from "../../assest/customers/customer8.jpg"; 

const AboutCustomers2 = () => {
  const customers = [
    { name: 'EPE PACKAGING', category: 'Manufacturing', logo: customer1 },
    { name: 'EGAT DIAMOND', category: 'Manufacturing', logo: customer2 },
    { name: 'SABINA', category: 'Manufacturing', logo: customer3 },
    { name: 'OL PRIVATE', category: 'Corporate', logo: customer4 },
    { name: 'NISSIN ELECTRIC', category: 'Manufacturing', logo: customer5},
    { name: 'THAI-NICHI', category: 'Manufacturing', logo: customer6},
    { name: 'MUSASHI AUTOPARTS', category: 'Manufacturing', logo: customer7 },
    { name: 'S&J INTERNATIONAL', category: 'Manufacturing', logo: customer8},
  ];

  return (
    <div className="about-partners">
      <h2 className="title">Customer Reference</h2>
      <h3 className="subtitle">This is the list of our Customers</h3>
      <p className="p-title">
        Thank you very much for all support from all customers. We  to provide the good product and well service.
      </p>
      <div className="customers-grid">
        {customers.map((customer, index) => (
          <div key={index} className="customer-card">
            <img src={customer.logo} alt={`${customer.name} Logo`} className="customer-logo" />
            <h4 className="customer-name">{customer.name}</h4>
            <span className={`customer-category category-${customer.category.toLowerCase()}`}>
              {customer.category}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutCustomers2;
